<template>
    <div class="pagefooter">
        <div class='footer_intro'>
            <div class='adress'>
                <ul>
                    <li>
                        <a v-for="item of footRoute" :key='item.name' @click='fRoute(item.fRoute)'>{{item.name}}</a>
                    </li>
                    <li>
                       <div class="foot-contact">
                           <el-popover
                            ref="popover"
                            placement="left"
                            width="200"
                            trigger="hover"
                            content="请拨打 400-1556-256 免费咨询服务热线">
                            </el-popover>
                            <!-- <el-popover
                            ref="popover2"
                            placement="top"
                            width="200"
                            trigger="hover"
                            content="请拨打 400-1556-256 免费咨询服务热线">
                            </el-popover> -->
                            <el-popover
                            ref="popover3"
                            placement="right"
                            width="100"
                            trigger="hover">
                            <img src='../assets/imgs/qrd.png' style="width: 90px;">
                            </el-popover>
                           <i class="icon1" v-popover:popover></i>
                           <i class="icon2" ></i>
                           <i class="icon3" v-popover:popover3></i>
                      </div>
                    </li>
                    <li>
                        <p style="margin-bottom: 8px">公司地址 北京市朝阳区慧忠里103号洛克时代中心A座703</p>
                        <p><small>京ICP备15053121号-1 京ICP证160142号 Copyright&copy;2015LuxuryKingDom 保留所有版权</small></p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                footRoute: [
                    {
                        name: '首页',
                        fRoute: 'Home'
                    } ,{
                        name: '业务介绍',
                        fRoute: 'Business'
                    } ,{
                        name: '公司介绍',
                        fRoute: 'intro'
                    } ,{
                        name: '新闻动态',
                        fRoute: 'news'
                    } ,{
                        name: '招贤纳士',
                        fRoute: 'hire'
                    } ,{
                        name: '联系我们',
                        fRoute: 'contact'
                    }
                ]
            }
        },
        methods: {
            fRoute(footRoute){
                if(footRoute=='hire'){
                    window.open('https://www.lagou.com/gongsi/103241.html')
                }else{
                    this.$router.push({ name: footRoute })
                    setTimeout(function(){
                        console.log(document.getElementById('app').scrollTop);
                        window.scrollBy(0,0)
                    },1)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .pagefooter{
        text-align:left;
        background:#202d3d;
        color:#fff;
        font-size:14px;
        width:100%;
        text-align: center;
        background: url('../assets/images/bg_footer@2x.jpg') no-repeat center;
        background-size: 100% 292px;
        .footer_intro{
            width:75%;
            padding:60px 0;
            margin:0 auto;
            .adress{
                li{
                    font-size: 16px;
                    margin-bottom:24px;
                    color:rgba(255,255,255,0.38);
                    a{
                        padding:0 16px;
                        cursor:pointer;
                        color:rgba(255,255,255,0.38);
                        &:hover{
                            color:rgba(255,255,255,1)
                        }
                    }
                    a:first-child{
                     padding-left:0;
                    }
                    .foot-contact {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        i {
                            width: 50px;
                            height: 50px;
                            margin: 0 16px;
                            border-radius: 50%;
                            &.icon1 {
                                background-image: url('../assets/images/iphone.png');
                            }
                            &.icon2 {
                                background-image: url('../assets/images/android.png');
                            }
                            &.icon3 {
                                background-image: url('../assets/images/weixin.png');
                            }
                            background-repeat: no-repeat;
                            background-position: center;
                            background-size: 32px ;
                            background-color: rgba(59, 69, 81, 1);
                            cursor: pointer;
                        }
                    }
                }
                li:last-child{
                    margin-bottom:0;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// foot.vue?8efd3c54